
const SimulationComment = (props) => {
    const {comment = "N/A", title="", mt=0, mb=0} = props;
    return (
        <div className={`col-12 mt-${mt} mb-${mb} pl-0`}>
        <h3 className="mb-1">{title} comment</h3>
        <span style={{whiteSpace: "pre-line"}}>{comment || "N/A"} </span>
    </div>);
};
export default SimulationComment;